import ARange from './Range.vue';
export default ARange;


// WEBPACK FOOTER //
// ./src/packages/Range/index.js